module.exports = __webpack_public_path__ + "img/ghl-logo-dark.fe633d2a.png";